import styled from "styled-components";

export const Checkbox = styled.input`
  margin-right: 20px;
`;
